import movement from '@/api/product-movement'

import { baseState, baseMutations } from '@/store/mixins'
import { join } from 'lodash'
import moment from 'moment'

export const state = {
  ...baseState,
  branch_id: undefined,
  product_id: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID(state, value){
    state.branch_id = value
  },
  SET_PRODUCT_ID(state, value){
    state.product_id = value
  },
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          branch_id: join(context.state.branch_id, ','),
          date_between: join(context.state.dateRange, ','),
          product_id: join(context.state.product_id, ','),
        }
      },
      attrubutes
    )
    return movement.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  searchProduct(context, attributes = {}) {
    return movement.searchProduct({ params: attributes }).then(response => {
      return response
    })
  },
  excel(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          branch_id: join(context.state.branch_id, ','),
          product_id: join(context.state.product_id, ','),
        }
      },
      attrubutes
    )
    return movement.excel({ params })
  }
}
